import {BaseGameTemplateAnimationSetModel} from "./base-game-template-animation-set-model";

export class MajorGameEventTemplateAnimationSetModel extends BaseGameTemplateAnimationSetModel {}
